(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('OwnProfileDialogController', OwnProfileDialogController);

    OwnProfileDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'OwnProfile'];

    function OwnProfileDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, OwnProfile) {
        var vm = this;

        vm.ownProfile = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ownProfile.id !== null) {
                OwnProfile.update(vm.ownProfile, onSaveSuccess, onSaveError);
            } else {
                OwnProfile.save(vm.ownProfile, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('publicGatewayApp:ownProfileUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dob = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
